export enum ContractGeneratorRequestType {
    OFFER = 'offer',
    ORDER = 'order',
}
